<template>
    <div class="swiper">
        <template v-if='type == 1'>
            <div class='swiper1' :style="{background: urlb != '' ? 'url('+require('../assets/'+urlb)+') #ffffff no-repeat center' : '#ffffff'}">
                <div class='swiper1_content'>
                    <h2>{{title}}</h2>
                    <div>
                        <div class='p_tab'>
                            <div v-for='(item,index) in swiper1List' :key='index' @mouseover='swiper1Num = index,setActiveItem1(index)' :class='swiper1Num == index ? "open" : ""'>{{item}}</div>
                        </div>
                    </div>
                    <div class='swiper1_Banner'>
                        <el-carousel :autoplay='false' ref="carousel1" @change='swiper1Change' :height='height' indicator-position="none">
                            <el-carousel-item v-for="(item,index) in swiper1_Banner" :key="index" name='index'>
                                <div class='ys-cj'>
                                    <img :src='item' />
                                </div>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                    <div class='sub' v-if='!isSub' :style="{width: width+'px'}" @click='visible = true'>{{text}}</div>
                </div>
            </div>
        </template>

        <template v-if='type == 2'>
            <div class='swiper2'>
                <div class='epr6_content'>
                    <h2>{{title}}</h2>
                    <div>
                        <div class='p_tab'>
                            <div v-for='(item,index) in swiper1List' :key='index' @mouseover='swiper1Num = index,setActiveItem1(index)' :class='swiper1Num == index ? "open" : ""'>{{item}}</div>
                        </div>
                    </div>
                    <div class='erp6Banner'>
                        <el-carousel :autoplay='false' ref="carousel1" @change='swiper1Change' :height='height' indicator-position="none">
                            <el-carousel-item v-for="(item,index) in swiper1_Banner" :key="index" name='index'>
                                <div class='B_c'>
                                    <div class='b_b_t'>
                                        <div v-for='(item1,index1) in 3' :key='index1'>
                                            <img :src='item["url"+item1]' />
                                            <p>{{item["title"+item1]}}</p>
                                            <p>{{item["text"+item1]}}</p>
                                            <p>{{item["name"+item1]}}</p>
                                        </div>
                                    </div>
                                    <div class='b_b_b' v-if='item.item'>
                                        <div v-for='(item2,index2) in item.item' :key='index2'>
                                            <img :src='item2' />
                                        </div>
                                    </div>
                                </div>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                    <div class='sub' v-if='!isSub' :style="{width: width+'px'}" @click='visible = true'>{{text}}</div>
                </div>
            </div>
        </template>

        <template v-if='type == 3'>
            <div class='swiper3'>
                <div class='swiper3_content'>
                    <h2>{{title}}</h2>
                    <div class='swiper_i'>
                        <el-carousel :autoplay='false' ref="carousel1" @change='swiper1Change' :height='height' indicator-position="none">
                            <el-carousel-item v-for="(item,index) in swiper1_Banner" :key="index" name='index'>
                                <div class='aaa'>
                                    <div v-for='(item2,index2) in item' :key='index2'>
                                        <div><img :src='item2.url' /></div>
                                        <p>{{item2.title}}</p>
                                        <span>{{item2.content}}</span>
                                    </div>
                                </div>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                </div>
            </div>
        </template>

        <Loding :visible.sync='visible'></Loding>
    </div>
</template>

<script>
export default {
    name: 'swiper',
    props:{
        // 按钮宽度
        width: {
            type: String,
            default: ''
        },
        // 是否展示按钮
        isSub: {
            type: Boolean,
            default: false
        },
        // 轮播图高度
        height: {
            type: String,
            default: '580px'
        },
        // tab
        swiper1List: {
            type: Array,
            default: []
        },
        // 轮播图
        swiper1_Banner: {
            type: Array,
            default: ''
        },
        // 标题
        title: {
            type: String,
            default: ''
        },
        // 按钮内容
        text: {
            type: String,
            default: '获取解决方案'
        },
        // 背景图
        urlb: {
            type: String,
            default: ''
        },
        // 轮播图类型
        type: {
            type: String,
            default: '1'
        }
    },
    data() {
        return {
            visible: false,
            swiper1Num: 0,
        }
    },
    mounted() {
        console.log(this.swiper1_Banner)
    },
    methods:{
        // 设置4轮播图位置
        setActiveItem1(index) {
            this.$refs.carousel1.setActiveItem(index);
        },
        // 改变4轮播图位置
        swiper1Change(index) {
            this.swiper1Num = index;
        },
    }
}
</script>

<style lang="scss" scoped>
    .swiper{
        .swiper1{
            padding-top: 70px;
            background-size: 100% 100% !important;
            min-height: 300px;
            padding-bottom: 90px;
            .swiper1_content{
                width: 75rem;
                margin: 0 auto;
                position: relative;
                h2{
                    font-size: 30px;
                    line-height: 40px;
                    letter-spacing: 2px;
                    color: #e31924;
                    // font-weight: bold;
                    text-align: center;
                }
                >div:first-of-type{
                    border-bottom: 1px solid #979797;
                }
                .p_tab{
                    margin-top: 50px;
                    display: flex;
                    justify-content: space-between;
                    color: #000000;
                    padding:0 80px;
                    >div{
                        // flex: 1;
                        text-align: center;
                        font-size: 16px;
                        line-height: 23px;
                        letter-spacing: 1px;
                        color: #707070;
                        cursor: pointer;
                        transition: all 0.3s !important;
                        position: relative;
                        padding-bottom: 18px;
                        line-height: 2;
                    }
                    .open{
                        color: #f8000c!important;
                    }
                    .open::after{
                        background: #f8000c;
                        display: block;
                        height: 4px;
                        position: absolute;
                        top: auto;
                        bottom: 0;
                        border-radius: 2px;
                        width: 100%;
                        transition: all 0.3s !important;
                        left: 0;
                        content: " ";
                    }
                }
                .ys-cj{
                    >img{
                        width: 100%;
                        height: 100%；
                    }
                    >h3{
                       font-size: 20px;
                        font-weight: bold;
                        line-height: 26px;
                        letter-spacing: 1px;
                        color: #e31824;
                        text-align: center;
                    }
                }
                .swiper1_Banner{
                    margin-top: 36px;
                }
                .sub{
                    width: 205px;
                    height: 46px;
                    line-height: 46px;
                    color: #ffffff;
                    font-size: 18px;
                    text-align: center;
                    background-image: linear-gradient(131deg, #e5732d 0%, #e31924 52%);
                    border-radius: 6px;
                    margin: 100px auto 0;
                    cursor: pointer;
                }
            }
        }

        .swiper2{
            background: url(../assets/epr6.jpg) #fff no-repeat center center;
            background-size: cover;
            padding-bottom: 50px;
            .epr6_content{
                width: 75rem;
                margin: 0 auto;
                padding-top: 70px;
                position: relative;
                h2{
                    font-size: 30px;
                    line-height: 40px;
                    letter-spacing: 2px;
                    color: #e31924;
                    font-weight: bold;
                    text-align: center;
                }
                >div:first-of-type{
                    width: 75rem;
                    margin: 0 auto;
                    border-bottom: 1px solid #979797;
                }
                .p_tab{
                    margin-top: 50px;
                    display: flex;
                    justify-content: space-between;
                    color: #000000;
                    padding: 0 80px;
                    >div{
                        // flex: 1;
                        text-align: center;
                        font-size: 16px;
                        line-height: 23px;
                        letter-spacing: 1px;
                        color: #707070;
                        cursor: pointer;
                        transition: all 0.3s !important;
                        position: relative;
                        padding-bottom: 18px;
                        line-height: 2;
                    }
                    .open{
                        color: #f8000c!important;
                    }
                    .open::after{
                        background: #f8000c;
                        display: block;
                        height: 4px;
                        position: absolute;
                        top: auto;
                        bottom: 0;
                        border-radius: 2px;
                        width: 100%;
                        transition: all 0.3s !important;
                        left: 0;
                        content: " ";
                    }
                }
                .erp6Banner{
                    background: #ffffff;
                    border-radius: 6px;
                    margin-top: 20px;
                    .B_c{
                        .b_b_t{
                            display: flex;
                            >div{
                                text-align: justify;
                                margin: 46px 44px 15px;
                                flex: 1;
                                >img{
                                    width: auto;
                                    height: 50px;
                                }
                                >p:nth-of-type(1) {
                                    font-weight: bold;
                                    font-size: 18px;
                                    color: #000000;
                                    line-height: 1.4;
                                    margin-top: 13px;
                                    margin-bottom: 10px;
                                }
                                >p:nth-of-type(2) {
                                    min-height: 156px;
                                    font-size: 14px;
                                    color: #717070;
                                }
                                >p:nth-of-type(3) {
                                    font-size: 14px;
                                    color: #717070;
                                    text-align: right;
                                }
                            }
                        }
                        .b_b_b{
                            margin-top: 24px;
                            display: flex;
                            justify-content: center;
                            flex-wrap: wrap;
                            >div{
                                width: calc(20% - 32px);
                                border-radius: 8px;
                                height: 58px;
                                margin: 0 8px 20px;
                                overflow: hidden;
                                transition: all 0.3s !important;
                                border: 1px solid #E1E1E1;
                                cursor: pointer;
                                >img{
                                    width: 100%;
                                    height: 100%;
                                }
                            }
                            >div:hover{
                                transform: translateY(-8px);
                            }
                        }
                    }
                }
                .sub{
                    font-size: 18px;
                    color: #ffffff;
                    border-radius: 4px;
                    background: linear-gradient(135deg, #E97528 0%, #E90713 100%);
                    width: 354px;
                    height: 54px;
                    padding: 0;
                    transition: background 0.2s !important;
                    cursor: pointer;
                    margin: 40px auto 0;
                    text-align: center;
                    line-height: 54px;
                }
            }
        }

        .swiper3{
            background: #f4f4f4;
            padding-bottom: 50px;
            .swiper3_content{
                width: 75rem;
                margin: 0 auto;
                padding-top: 70px;
                position: relative;
                h2{
                    font-size: 30px;
                    line-height: 40px;
                    letter-spacing: 2px;
                    color: #e31924;
                    font-weight: bold;
                    text-align: center;
                }
                .swiper_i{
                    width: 100%;
                    margin-top: 36px;
                    .aaa{
                        width: 100%;
                        align-items: center;
                        height: 450px;
                        //display: flex;
                        >div{
                            width: 390px;
                            background: #fff;
                            box-shadow: 0 0 6px 6px rgba(196, 197, 205, 0.2);
                            height: 99%;
                            margin-right: 15px;
                            border: 1px solid #e8e8e8;
                            text-align: center;
                            >div{
                                width: 330px;
                                height: 145px;
                                background: #f4f4f4;
                                text-align: center;
                                line-height: 145px;
                                margin: 52px auto 36px;
                                >img{
                                    display: inline-block;
                                    vertical-align: middle;
                                    max-height: 90px;
                                    max-width: 250px;
                                }
                            }
                            >p{
                                font-size: 20px;
                                color: #333;
                                margin-bottom: 14px;
                                text-align: center;
                            }
                            >span{
                                width: 326px;
                                margin: 0 auto;
                                display: inline-block;
                                font-size: 14px;
                                color: #999;
                                line-height: 32px;
                            }
                        }
                        >div:hover{
                            border: 1px solid #e0060d;
                        }
                    }
                }
            }
        }
    }
</style>
<style scoped>
@media all and (min-width: 980px) {
    .footer2{
        display: none !important;
    }
    .footer1{
        display: block !important;
    }
    .swiper .swiper3 .swiper3_content .swiper_i .aaa{
        display: flex;
    }
    .swiper .swiper3 .swiper3_content .swiper_i .aaa{
        display: flex !important;
    }
}
@media all and (max-width: 980px) {
    .swiper .swiper3 .swiper3_content[data-v-de5112f0]{
        width: 100%;
    }
    .swiper .swiper3 .swiper3_content .swiper_i .aaa{
        display: initial;
    }
    .swiper .swiper3{
        overflow: hidden;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/swiper.vue